<div class="padding-bottom-15">  
  <form [formGroup]="sliderForm">
    <div>{{rangeData.title}}</div>
    <span class="custom-slider">
      <ng5-slider [options]="options" formControlName="sliderControl" (ngModelChange)="chosenOptions()"></ng5-slider>
    </span>
  </form>
</div>